import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from 'app/components/Tooltip';
import css from './style.scss';
import Searchicon from "../../../assets/images/Search-icons.svg";
import SearchIconActive from "../../../assets/images/search-icon-active.svg";
import AIicon from "../../../assets/images/AI-icon.svg";
import AiStarIcon from "../../../assets/images/ai-star-icon.svg";

export const SearchModeOptions = {
  LOCATION: 'LOCATION',
  AI: 'AI',
};

const SearchModeToggle = ({ mode, onChange, className }) => {
  const isLocationActive = mode === SearchModeOptions.LOCATION;
  const isAiActive = mode === SearchModeOptions.AI;

  return (
    <div className={classNames(css.searchModeToggle, className)} role="tablist" aria-label="Search mode">
      <Tooltip content="Search" position="bottom"   xOffset={18}
  yOffset={-10}
  arrowOffset={20}>
        <button
          type="button"
          role="tab"
          aria-selected={isLocationActive}
          className={classNames(css.searchModeOption, css.locationOption, { [css.active]: isLocationActive })}
          onClick={() => onChange(SearchModeOptions.LOCATION)}
        >
          <img src={isLocationActive ? SearchIconActive : Searchicon} alt="Location search" className={css.icon} />
        </button>
      </Tooltip>
      <Tooltip content="AI Search" position="bottom" xOffset={26}
  yOffset={-8}
  arrowOffset={20}>
        <button
          type="button"
          role="tab"
          aria-selected={isAiActive}
          className={classNames(css.searchModeOption, css.aiOption, { [css.active]: isAiActive })}
          onClick={() => onChange(SearchModeOptions.AI)}
        >
          <img src={isAiActive ? AIicon : AiStarIcon} alt="AI search" className={css.icon} />
        </button>
      </Tooltip>
    </div>
  );
};

SearchModeToggle.propTypes = {
  mode: PropTypes.oneOf(Object.values(SearchModeOptions)).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

SearchModeToggle.defaultProps = {
  className: '',
};

export default SearchModeToggle;
